import { render, staticRenderFns } from "./FormCalendarEvent.vue?vue&type=template&id=b7a5851c&scoped=true"
import script from "./FormCalendarEvent.js?vue&type=script&lang=js&external"
export * from "./FormCalendarEvent.js?vue&type=script&lang=js&external"
import style0 from "./FormCalendarEvent.vue?vue&type=style&index=0&id=b7a5851c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b7a5851c",
  null
  
)

export default component.exports